import PilotFaqsAPI from 'dashboard/api/pilot/faqs';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'PilotFaq',
  API: PilotFaqsAPI,
  getters: {
    getRecords: state => state.records,
  },
  actions: types => ({
    async update({ commit, state }, { id, data }) {
      commit(types.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await PilotFaqsAPI.update(id, data);

        const updatedRecords = state.records.map(record => {
          if (record.id === id) {
            return response.data.payload;
          }
          return record;
        });
        commit(types.SET, updatedRecords);

        commit(types.SET_UI_FLAG, { updatingItem: false });

        return response.data;
      } catch (error) {
        commit(types.SET_UI_FLAG, { updatingItem: false });
        throw error;
      }
    },
    async show({ commit }, params) {
      commit(types.SET_UI_FLAG, { fetchingList: true });
      try {
        const { data } = await PilotFaqsAPI.show(params.id, params);
        commit(types.SET_UI_FLAG, { fetchingList: false });
        return data;
      } catch (error) {
        commit(types.SET_UI_FLAG, { fetchingList: false });
        throw error;
      }
    },
    async filter(
      { commit },
      { page = 1, sortAttr, queryPayload, search, resetState = true } = {}
    ) {
      commit(types.SET_UI_FLAG, { fetchingList: true });
      try {
        const { data } = await PilotFaqsAPI.filter(
          page,
          sortAttr,
          queryPayload,
          search
        );
        if (resetState) {
          commit(types.SET, data.payload);
          commit(types.SET_META, data.meta);
        }
        commit(types.SET_UI_FLAG, { fetchingList: false });
        return data.payload;
      } catch (error) {
        commit(types.SET_UI_FLAG, { fetchingList: false });
        throw error;
      }
    },
  }),
});
